module.exports = __webpack_public_path__ + "assets/img/9a4c9eda34128f7f23c6e38c1e32fb16.png";